// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UnauthorizedHeader_wrap__11XjF"};